import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-97b99338"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-setting" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "audio-bar" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "audio-level" }),
  /*#__PURE__*/_createElementVNode("div", { class: "background" })
], -1))
const _hoisted_3 = { class: "text-sm font-medium mt-3 text-black" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base" }, "System Default Audio Output", -1))

import PreviewTwilio from '@/components/checkup/PreviewTwilio.vue'
import PreviewVideo from '@/components/checkup/PreviewVideo.vue'
import PreviewZoom from '@/components/checkup/PreviewZoom.vue'
import { useDeviceStore } from '@/stores'
import { Engine } from '@/types/enums/room.enum'
import { computed, onMounted, onUnmounted, PropType, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceSetting',
  props: {
  engine: {
    type: String as PropType<Engine>,
    default: Engine.TWILIO,
  },
},
  setup(__props) {

_useCssVars(_ctx => ({
  "5d5767eb": (audioLevelCss.value)
}))


// Store
const device = useDeviceStore()

// Computed
const audioLevelCss = computed(() => Math.max(0, 100 - device.audioLevel * 300))

onMounted(() => {
  device.maskSelectedVideo = device.selectedVideo
  device.maskSelectedAudio = device.selectedAudio
  device.maskSelectedSpeaker = device.selectedSpeaker
  if (device.maskMicrophoneOn) {
    device.getAudioLevelZoom()
  }
})

onUnmounted(() => {
  device.stopAudioLevelZoom()
})

watch(
  () => device.maskMicrophoneOn,
  async () => {
    if (device.maskMicrophoneOn) {
      if (device.localAudioTrack) {
        await device.localAudioTrack.unmute()
      }
      device.getAudioLevelZoom()
    } else {
      if (device.localAudioTrack) {
        await device.localAudioTrack.mute()
      }
      device.stopAudioLevelZoom()
    }
  },
)

return (_ctx: any,_cache: any) => {
  const _component_SelectOption = _resolveComponent("SelectOption")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(device).isReady)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (__props.engine === _unref(Engine).TWILIO)
            ? (_openBlock(), _createBlock(PreviewTwilio, {
                key: 0,
                "can-set-background": false,
                "is-auto-state": false
              }))
            : (__props.engine === _unref(Engine).ZOOM)
              ? (_openBlock(), _createBlock(PreviewZoom, {
                  key: 1,
                  "is-auto-state": false
                }))
              : (_openBlock(), _createBlock(PreviewVideo, { key: 2 }))
        ], 64))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createVNode(_component_SelectOption, {
      modelValue: _unref(device).maskSelectedVideo,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(device).maskSelectedVideo) = $event)),
      label: _ctx.$t('camera'),
      options: _unref(device).videoInputDevices
    }, null, 8, ["modelValue", "label", "options"]),
    _createVNode(_component_SelectOption, {
      modelValue: _unref(device).maskSelectedAudio,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(device).maskSelectedAudio) = $event)),
      label: _ctx.$t('microphone'),
      options: _unref(device).audioInputDevices
    }, null, 8, ["modelValue", "label", "options"]),
    (_unref(device).canSetSpeaker)
      ? (_openBlock(), _createBlock(_component_SelectOption, {
          key: 1,
          modelValue: _unref(device).maskSelectedSpeaker,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(device).maskSelectedSpeaker) = $event)),
          label: _ctx.$t('speaker'),
          options: _unref(device).audioOutputDevices
        }, null, 8, ["modelValue", "label", "options"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('speaker')), 1),
          _hoisted_4
        ], 64))
  ]))
}
}

})